import React from 'react';
import './App.css';
import Navigation from './components/Navigation';
import {
  Container, Row, Col
} from 'bootstrap-4-react';
import FirstRow from './components/FirstRow';
import QuestionsRow from './components/QuestionsRow';
import Speaker from './components/Speaker';
import Registration from './components/Registration';
import Gift from './components/Gift'
import Footer from './components/Footer';
import ForRow from './components/ForRow';
import EventProgram from './components/EventProgram';
import {
  BrowserRouter as Router,
  Switch,
  Route,
  Link
} from 'react-router-dom';
import buildlab from './buildlab.svg';
import tgicon from './tgicon.png'

const eventDate = {
  date: '17.11',
  time: '18:00'
}

function App (){
  return (
    <Switch>
      <Route path={ '/tg' }>
        <Container>
          <TelegramPage/>
        </Container>
      </Route>
      <Route path={ '/' }>
        <Container>
          <Navigation/>
          <FirstRow eventDate={ eventDate }/>
          <ForRow/>
          <EventProgram/>
          <QuestionsRow/>
          <Speaker/>
          <Registration eventDate={ eventDate }/>
          <Gift/>
          <Footer/>
        </Container>
      </Route>
    </Switch>
  );
}

const TelegramPage = () => {

  return (
    <div className={ 'tg-wrapper' }>
      <div style={{display: 'flex', flexDirection: 'column', alignItems: 'center'}}>
        <h1 id={ 'title' } style={ { textAlign: 'center' } }>Забирай чек-лист в Telegram</h1>
        <a href={'https://t.me/Sprayplast_BuildLabBot'} style={{color: 'white'}}>
          <img src={tgicon} width={200}/>
          <div style={{ textAlign: 'center' }}>Получить чек-лист</div>
        </a>
      </div>
      <img src={ buildlab } height={ 40 } style={ { marginBottom: 40 } }/>
    </div>
  )

}
export default App;
